import React from 'react';
import Button from '../CustomButton/Button'
import { HiCalendar } from "react-icons/hi";

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <Button ref={ref} onClick={onClick} variant="primary">
        {value ? `${value}` : 'Выберите дату'}
        <HiCalendar style={{ marginLeft: 12, marginBottom: 4 }} />
    </Button>
));

export default CustomInput